export const API_URL = 'https://pagamentos.neuropsicologia.online/api'
//export const API_URL = 'http://localhost:4000/api'
